import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              Engineering Excellence Through Innovation
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              MTClicks stands at the forefront of enterprise technology solutions, delivering 
              mission-critical systems that power digital transformation initiatives across industries. 
              Our team of certified architects and engineers specializes in building resilient, 
              scalable infrastructure that adapts to evolving business requirements.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              From legacy system modernization to greenfield cloud-native applications, we architect 
              solutions that optimize performance, enhance security, and drive operational efficiency. 
              Our methodology combines agile development practices with DevSecOps principles to ensure 
              rapid delivery without compromising quality or security.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Core Competencies</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Cloud Architecture & Migration</li>
                  <li>• Microservices & API Design</li>
                  <li>• DevOps & CI/CD Automation</li>
                  <li>• Security & Compliance</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Certifications</h4>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• AWS Solutions Architect</li>
                  <li>• Azure DevOps Engineer</li>
                  <li>• Kubernetes Administrator</li>
                  <li>• Security+ & CISSP</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="relative">
            <div className="bg-gradient-to-br from-blue-100 to-cyan-100 rounded-2xl p-8">
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <i className="fas fa-award text-3xl text-primary mb-3"></i>
                  <h4 className="font-semibold text-gray-900">ISO 27001</h4>
                  <p className="text-sm text-gray-600">Certified Security Management</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <i className="fas fa-certificate text-3xl text-accent mb-3"></i>
                  <h4 className="font-semibold text-gray-900">SOC 2 Type II</h4>
                  <p className="text-sm text-gray-600">Compliance & Audit Ready</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <i className="fas fa-globe text-3xl text-secondary mb-3"></i>
                  <h4 className="font-semibold text-gray-900">Global Reach</h4>
                  <p className="text-sm text-gray-600">Multi-Region Deployment</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-sm">
                  <i className="fas fa-users text-3xl text-primary mb-3"></i>
                  <h4 className="font-semibold text-gray-900">Expert Team</h4>
                  <p className="text-sm text-gray-600">Senior Engineers & Architects</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
